import Header from '@/components/Header';
import Footer from '@/components/ui/footer';
import HeroBass from '@/components/landing/bass/HeroBass';
import WhyChooseCelloBass from '@/components/landing/bass/WhyChooseCelloBass';
import AwardsBass from '@/components/landing/bass/AwardsBass';
import HowItWorksBass from '@/components/landing/bass/HowItWorksBass';
import JoySectionBass from '@/components/landing/bass/JoySectionBass';
import PricingEdits from '@/components/landing/bass/PricingEdits';
import FAQSectionBass from '@/components/landing/bass/FAQSectionBass';
import TestimonialsBass from '@/components/landing/bass/TestimonialsBass';
import CTABass from '@/components/landing/bass/CTABass';
import { motion, useScroll, useSpring } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import WaitlistDialog from "./../components/landing/bass/WaitlistDialog";

declare global {
    interface Window {
        Trustpilot?: { loadFromElement: (el: HTMLElement, reload?: boolean) => void };
    }
}

const SanFrancisco = () => {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001
    });
    const trustpilotRef = useRef<HTMLDivElement>(null);
    const [showWaitlist, setShowWaitlist] = useState(false);

    useEffect(() => {
        const link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap';
        link.rel = 'stylesheet';
        document.head.appendChild(link);

        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17584005510';
        document.head.appendChild(gtagScript);

        const gtagInlineScript = document.createElement('script');
        gtagInlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17584005510');
        `;
        document.head.appendChild(gtagInlineScript);

        if (window.Trustpilot && trustpilotRef.current) {
            window.Trustpilot.loadFromElement(trustpilotRef.current, true);
        }

        return () => {
            document.head.removeChild(link);
            document.head.removeChild(gtagScript);
            document.head.removeChild(gtagInlineScript);
        };
    }, []);

    return (
        <div className="min-h-screen bg-white font-inter selection:bg-[#FF8B11] selection:text-white">
            <motion.div
                className="fixed top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-[#FF8B11] to-[#FFD700] origin-left z-[100]"
                style={{ scaleX }}
            />

            {/* Announcement Banner */}
            <div className="bg-[#5A2A0D] text-white py-2.5 px-4 text-center text-xs sm:text-sm tracking-wide z-[90] relative top-0 w-full flex items-center justify-center gap-2">
                <span className="font-medium text-white/90">We're at full capacity at the moment.</span>
                <button 
                  onClick={() => setShowWaitlist(true)} 
                  className="font-bold underline underline-offset-4 decoration-[#FFD700]/50 hover:decoration-[#FFD700] hover:text-[#FFD700] transition-colors"
                >
                  Tap here to join the waitlist
                </button>
            </div>

            <Header logoVariant="white" onGetStartedClick={() => setShowWaitlist(true)} />

            <main>
                <HeroBass
                    headlineWords={[
                        { text: "San Francisco,", italic: false },
                        { text: "let", italic: false },
                        { text: "the", italic: false },
                        { text: "experts", italic: false },
                        { text: "dress", italic: true },
                        { text: "you.", italic: false },
                    ]}
                    subtitle="Expert styling for the Bay Area — outsource the shopping and the guesswork."
                    onGetStartedClick={() => setShowWaitlist(true)}
                />
                <WhyChooseCelloBass />
                <AwardsBass />
                <HowItWorksBass />
                <JoySectionBass />
                <TestimonialsBass />
                <PricingEdits onJoinClick={() => setShowWaitlist(true)} />
                <FAQSectionBass />
                <CTABass onGetStartedClick={() => setShowWaitlist(true)} />
            </main>

            <Footer />
            <WaitlistDialog open={showWaitlist} onOpenChange={setShowWaitlist} />
        </div>
    );
};

export default SanFrancisco;
